import React from 'react';
import icon from "../../assets/images/noaccess.png"
import i18n from '../../i18n';

class NoAccess extends React.Component {   
    render() {
        return (
            <div className='mt-5'>
                <div className='text-center noaccess pt-5 pb-5'>
                    <div className='mt-5 mb-5'>
                       <img src={icon} alt="No Access" className='noaccess-icon' height={150}></img>
                    </div>
                    <div className='mt-5'>
                       <h3 className='noaccess-h3'>{i18n.t(`CommonCode.TextNoAccessMessage`)}</h3>
                    </div>
                </div>
            </div>
        )
    }
}

export default NoAccess